import { z } from 'zod';

import { strings } from '@/i18n/strings';

function fill(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => String(values[key] ?? ''));
}

/**
 * Zod xatolarining o'zbekcha matnlari.
 *
 * **Nega markazda.** Tekshiruv qoidalari `@qaytim/shared` dagi sxemalarda yashaydi — va bu
 * to'g'ri: server bilan panel bir xil qoidani tekshirishi kerak. Ammo o'sha sxemalar ingliz
 * tilida standart xabar beradi ("String must contain at least 3 character(s)"), va u
 * to'g'ridan-to'g'ri operatorning ekraniga chiqardi. Har bir formada qo'lda xabar yozish
 * muqobili bir xil qoidani turli jumlalar bilan tushuntirishga olib kelardi.
 *
 * **Sxemaning O'Z xabari ustun.** `custom` va aniq `message` bilan berilgan xatolar shu holicha
 * qoladi: agar shartnoma muallifi maxsus jumla yozgan bo'lsa, u shu qoidaning eng aniq
 * tushuntirishi — uni umumiy matn bilan almashtirish ma'lumot yo'qotardi.
 */
const uzbekErrorMap: z.ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === 'undefined' || issue.received === 'null') {
        return { message: strings.validation.required };
      }
      // `nan` — bo'sh raqamli maydon (`numberField` uni shunday o'giradi).
      if (issue.received === 'nan') return { message: strings.validation.numberRequired };
      if (issue.expected === 'number') return { message: strings.validation.numberRequired };
      return { message: strings.validation.invalid };

    case z.ZodIssueCode.too_small:
      if (issue.type === 'string') {
        return {
          message:
            issue.minimum === 1
              ? strings.validation.required
              : fill(strings.validation.tooShort, { min: Number(issue.minimum) }),
        };
      }
      /*
        `positive()` chegarani NOL deb, ammo `inclusive: false` bilan beradi. Uni umumiy matn
        bilan tushuntirish "Eng kichik qiymat: 0" degan jumlaga aylanardi — va nol aynan
        qabul qilinmaydigan qiymat.
      */
      if (!issue.inclusive) return { message: strings.validation.positiveRequired };
      return { message: fill(strings.validation.tooSmall, { min: Number(issue.minimum) }) };

    case z.ZodIssueCode.too_big:
      if (issue.type === 'string') {
        return { message: fill(strings.validation.tooLong, { max: Number(issue.maximum) }) };
      }
      return { message: fill(strings.validation.tooBig, { max: Number(issue.maximum) }) };

    case z.ZodIssueCode.not_multiple_of:
      return { message: strings.validation.integerRequired };

    default:
      // `custom` va boshqalar: sxemaning o'z matni bo'lsa — o'sha, bo'lmasa umumiy jumla.
      return { message: ctx.defaultError === '' ? strings.validation.invalid : ctx.defaultError };
  }
};

/**
 * Xabarlarni GLOBAL o'rnatadi.
 *
 * Zod ning `errorMap` ini har bir `parse` chaqiruviga uzatib bo'lardi, ammo tekshiruvni
 * `zodResolver` ishga tushiradi va u sxemani o'zi chaqiradi. Global xarita — yagona joy
 * bo'lib, u shartnoma sxemalariga ham (`@qaytim/shared`) tegishli bo'ladi.
 *
 * Ilova ishga tushganda va sinovlar sozlanganda chaqiriladi: aks holda sinovlarda ingliz
 * tilidagi xabar ko'rinardi va sinov o'zi tekshirmoqchi bo'lgan matnni topa olmasdi.
 */
export function installAdminZodMessages(): void {
  z.setErrorMap(uzbekErrorMap);
}
